import { OrganizationMetadata } from '@sonar-software/sonar-core';
import { useMemo } from 'react';
import { useOrganizations } from './useOrganizations';

export function useSalesforceOrganizations(): OrganizationMetadata[] {
	const organizations = useOrganizations();

	return useMemo(
		() => organizations.filter(
			(org) => org.hasSalesforceData ||
				org.salesforceSyncInProgress ||
				org.salesforceSyncFailed ||
				(org.instanceUrl && org.instanceUrl.includes('salesforce'))
		),
		[ organizations ]
	);
}
